import DailyAggregateTable, { type DailyAggregateConfig, type DailyAggregateExtraColumn } from '../../components/DailyAggregateTable';
import { LocalStorageKeys } from '../../util/constants';

const POS_COLUMN: DailyAggregateExtraColumn = {
	accessorKey: 'depot',
	headerKey: 'common:tables.pos',
};

const PAYMENT_MODE_CONFIG: DailyAggregateConfig = {
	storageKey: LocalStorageKeys.PAYMENT_MODE_RECORDS,
	headerKey: 'common:payments.headers.byMode',
	endpoint: 'payments/modes',
	exportPrefix: 'payments_by_mode',
	dimensionKey: 'mode',
	dimensionHeaderKey: 'common:tables.mode',
	extraColumns: [
		{ accessorKey: 'user', headerKey: 'common:tables.user' },
		{ accessorKey: 'y_type', headerKey: 'common:tables.entryType' },
		POS_COLUMN,
	],
	highlightRefunds: true,
	enablePaymentCreate: true,
};

const PAYMENT_TYPE_CONFIG: DailyAggregateConfig = {
	storageKey: LocalStorageKeys.PAYMENT_TYPE_RECORDS,
	headerKey: 'common:payments.headers.byType',
	endpoint: 'payments/types',
	exportPrefix: 'payments_by_type',
	dimensionKey: 'x_type',
	dimensionHeaderKey: 'common:tables.type',
	extraColumns: [
		{ accessorKey: 'user', headerKey: 'common:tables.user' },
		{ accessorKey: 'y_type', headerKey: 'common:tables.entryType' },
		POS_COLUMN,
	],
	highlightRefunds: true,
	enablePaymentCreate: true,
};

const PAYMENT_USER_CONFIG: DailyAggregateConfig = {
	storageKey: LocalStorageKeys.PAYMENT_USER_RECORDS,
	headerKey: 'common:payments.headers.byUser',
	endpoint: 'payments/users',
	exportPrefix: 'payments_by_user',
	dimensionKey: 'user',
	dimensionHeaderKey: 'common:tables.user',
	extraColumns: [POS_COLUMN],
	highlightRefunds: true,
};

const PAYMENT_DEPOT_CONFIG: DailyAggregateConfig = {
	storageKey: LocalStorageKeys.PAYMENT_DEPOT_RECORDS,
	headerKey: 'common:payments.headers.byDepot',
	endpoint: 'payments/depots',
	exportPrefix: 'payments_by_depot',
	dimensionKey: 'depot',
	dimensionHeaderKey: 'common:tables.pos',
	highlightRefunds: true,
};

export const PaymentModeDaily = () => <DailyAggregateTable config={PAYMENT_MODE_CONFIG} />;
export const PaymentTypeDaily = () => <DailyAggregateTable config={PAYMENT_TYPE_CONFIG} />;
export const PaymentUserDaily = () => <DailyAggregateTable config={PAYMENT_USER_CONFIG} />;
export const PaymentDepotDaily = () => <DailyAggregateTable config={PAYMENT_DEPOT_CONFIG} />;